<template>
  <v-content class="dunbuild">
    <h1>Coming Soon!</h1>
    <h1>Enjoy this picture of my FF14 character that someone drew and click it for their Twitter!</h1>
    <v-container fluid fill-height>
      <v-layout align-center justify-center>
        <a id ="pic" href = "https://twitter.com/raika_heal_me" target="_blank">
          <img alt="Kanata" src="../assets/Kanata.jpg">
        </a>
      </v-layout>
    </v-container>
  </v-content>
</template>
<script>
export default {
    name: 'DungeonBuilder',
    data() {
        return {
            
        }
    },
    mounted() {

    }
}
</script>
<style>
</style>